import useMenuItemsInsertStatement from '../../menuItems/useMenuItemsInsertStatement.mjs'
import extendNode from '../extendNode.mjs'
import {lintForCode, lintForDoc} from '../AR/lint.mjs'
import useArCatNode from '../_AR_CAT/useArCatNode.jsx'
import meta from './metaBdlogicTarget.mjs'

export default () => {
    const ArCatNode = useArCatNode()
    const menuItemsInsertStatement = useMenuItemsInsertStatement()

    return extendNode(ArCatNode, {
        ...meta,

        canInsertStatement(map, node, statement) {
            return true
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'AR'},
                ...menuItemsInsertStatement,
            ]
        },

        async lintTree(map, node, type) {
            ({
                code: () => lintForCode(map, node),
                doc: () => lintForDoc(map, node),
            })[type]?.()
        },
    })
}
